import { render, staticRenderFns } from "./PrintItineraryServices.vue?vue&type=template&id=620bb8a0&"
import script from "./PrintItineraryServices.vue?vue&type=script&lang=js&"
export * from "./PrintItineraryServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports